const files = require.context('', false, /\.js$/)
let modules = {}
files.keys().forEach(key => {
  if (key !== './index.js') {
    modules = { ...modules, ...files(key).default }
  }
  // modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

// 中文
export default modules
